document.addEventListener("DOMContentLoaded", () => {
  const buttons = document.querySelectorAll(".accordion-button");

  const minusSVG = `
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="1" viewBox="0 0 12 1" fill="none">
      <path d="M1.3335 0.5H10.6668" stroke="#111111" stroke-linecap="square" stroke-linejoin="round"/>
    </svg>
  `;

  const plusSVG = `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
      <path d="M8 3.94803V13.2814" stroke="#111111" stroke-linecap="square" stroke-linejoin="round"/>
      <path d="M3.33337 8.61469H12.6667" stroke="#111111" stroke-linecap="square" stroke-linejoin="round"/>
    </svg>
  `;

  // Ouvrir le premier accordéon par défaut
  if (buttons.length > 0) {
    const firstButton = buttons[0];
    const firstIndex = firstButton.getAttribute("data-index");
    const firstSectionId = firstButton.getAttribute("data-section-id");
    const firstContent = document.getElementById(`content-${firstSectionId}-${firstIndex}`);
    const firstIcon = document.getElementById(`icon-${firstSectionId}-${firstIndex}`);

    if (firstContent && firstIcon) {
      firstContent.style.maxHeight = firstContent.scrollHeight + 'px';
      firstIcon.innerHTML = minusSVG;
      firstButton.classList.add('active');
    }
  }

  buttons.forEach(button => {
    button.addEventListener("click", () => {
      const index = button.getAttribute("data-index");
      const sectionId = button.getAttribute("data-section-id");

      const content = document.getElementById(`content-${sectionId}-${index}`);
      const icon = document.getElementById(`icon-${sectionId}-${index}`);

      const isOpen = content.style.maxHeight && content.style.maxHeight !== '0px';

      // Fermer tous les accordéons
      buttons.forEach(otherButton => {
        const otherIndex = otherButton.getAttribute("data-index");
        const otherSectionId = otherButton.getAttribute("data-section-id");
        const otherContent = document.getElementById(`content-${otherSectionId}-${otherIndex}`);
        const otherIcon = document.getElementById(`icon-${otherSectionId}-${otherIndex}`);

        otherContent.style.maxHeight = '0';
        otherIcon.innerHTML = plusSVG;
        otherButton.classList.remove('active');
      });

      // Ouvrir celui qu'on a cliqué (si ce n'était pas déjà ouvert)
      if (!isOpen) {
        content.style.maxHeight = content.scrollHeight + 'px';
        icon.innerHTML = minusSVG;
        button.classList.add('active');
      }
    });
  });
});
